import { useQuery } from '@tanstack/react-query';
import { GlobalReactQueryOptions } from '../../../../config';
import { fetchReserveReports } from './apiFetchReserveReports';
import { GroupingState } from '../../../../store/grouping/state';

const RESERVE_REPORTS_QUERY = 'reserveReports';

export const useGetReserveReports = (financialYear: number | string, grouping?: GroupingState) => {
    return useQuery(
        [RESERVE_REPORTS_QUERY, { financialYear, grouping }],
        () => fetchReserveReports({ financialYear, grouping }),
        { ...GlobalReactQueryOptions, enabled: !!financialYear }
    );
};
